import appConfig from 'helper/mapBackendConfig';

export const getAccessToken = async () => {
	if (process.env.NODE_ENV === 'development') {
		return new Promise((resolve) => {
			setTimeout(()=> {
				resolve('insert_access_token_for_local_development');
			},500);
		});
	} else {
		return fetch(appConfig.env.msrcConfig.accessTokenEndpoint, {
			method: 'POST',
			credentials: 'same-origin',
		})
			.then(async (response) => {
				if (response.status === 200) {
					const data = await response.json();
					return data.token ? data.token : '';
				}
				return '';
			})
			.catch(() => {
				return '';
			});
	}
};
